import { Form } from 'antd';
import { FormProviderProps } from 'antd/es/form/context';
import { PropsWithChildren, createContext, useContext, useState } from 'react';

import { CommonSteeringFilters } from 'business/steering/providers/steering-filters-provider/types';

const FILTERS_FORM_NAME = 'steering-chart-filters-form';

const defaultFilters = {
  position: 'rear',
  scale: 50,
  tolerance: 50,
} satisfies CommonSteeringFilters;

const SteeringChartFiltersContext =
  createContext<CommonSteeringFilters>(defaultFilters);

const SteeringChartFiltersProvider = ({
  initialFilters,
  children,
}: PropsWithChildren<{
  initialFilters: CommonSteeringFilters;
}>) => {
  const [filters, setFilters] = useState(initialFilters);

  const onFormChange: FormProviderProps['onFormChange'] = (
    formName,
    { forms },
  ) => {
    if (formName === FILTERS_FORM_NAME) {
      const form = forms[FILTERS_FORM_NAME];

      const values = {
        ...filters,
        ...form.getFieldsValue(),
      };

      // Setting default range for both day and ring because Antd Form remove the fields value if the input is
      // not rendered. Since we conditionnaly render the dateRange or ringRange depending on the `filterType`
      // it is required to add them with defaut value to the FiltersProvider. Therefore, we're sure it is always
      // defined when the filterType is changed
      setFilters(values);
      form.setFieldsValue(values);
    }
  };

  return (
    <SteeringChartFiltersContext.Provider value={filters}>
      <Form.Provider onFormChange={onFormChange}>{children}</Form.Provider>
    </SteeringChartFiltersContext.Provider>
  );
};

const useSteeringChartFiltersFormName = () => FILTERS_FORM_NAME;

const useSteeringChartFilters = () => useContext(SteeringChartFiltersContext);

export {
  SteeringChartFiltersProvider,
  useSteeringChartFiltersFormName,
  useSteeringChartFilters,
};
